import React, {useState} from 'react';
import ModalContainer from '../../../uiToolkit/ModalContainer';
import TextInput from '../../../uiToolkit/Inputs/TextInput';
import Button from '../../../uiToolkit/Buttons/Button';
import {
  PROJECT_NAME_MAX_LENGTH,
  Project,
} from '../../../data/models/Projects/Project';
import {projectsText} from '../projectsText';
import styles from './ProjectFormModal.module.css';

interface Props {
  project?: Project;
  isLoading: boolean;
  onSubmit: (name: string) => void;
  onClose: () => void;
}

const ProjectFormModal = React.memo(
  ({project, isLoading, onSubmit, onClose}: Props) => {
    const [name, setName] = useState(project?.name ?? '');
    const unchanged = !!project && name.trim() === project.name;

    return (
      <ModalContainer onClose={onClose} className={styles.modal}>
        <div className={styles.content}>
          <h3 className={styles.title}>
            {project ? projectsText.renameProject : projectsText.createProject}
          </h3>
          <TextInput
            heading={projectsText.projectName}
            placeholder={projectsText.projectNamePlaceholder}
            value={name}
            onChange={setName}
            maxCharacters={PROJECT_NAME_MAX_LENGTH}
            isMandatory
          />
          <div className={styles.actions}>
            <Button
              title={projectsText.cancel}
              uiType="text"
              onClick={onClose}
            />
            <Button
              title={projectsText.save}
              disabled={!name.trim() || unchanged}
              isLoading={isLoading}
              onClick={() => onSubmit(name.trim())}
            />
          </div>
        </div>
      </ModalContainer>
    );
  },
);

export default ProjectFormModal;
